import { IMemberLicensePlate, IMemberLicensePlateResponse } from '@/types';
import { fetchTemplate } from '@/utils/isServer';

class MemberLicensePlateService {
  public async GetMemberLicensePlates(): Promise<Array<IMemberLicensePlate>> {
    const res = await fetch(`/api/MemberLicensePlate`, {
      ...fetchTemplate,
      method: 'get',
    });

    const memberLicensPlatesResponse: IMemberLicensePlateResponse =
      await res.json();
    if (memberLicensPlatesResponse.status == 'OK')
      return memberLicensPlatesResponse.data;
    return [];
  }
  public async AddLicensePlate(card: IMemberLicensePlate): Promise<any> {
    const res = await fetch(`/api/MemberLicensePlate`, {
      ...fetchTemplate,
      body: JSON.stringify(card),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return await res.json();
  }
  public async DeleteLicensePlate(
    member_licenseplate_id: number
  ): Promise<any> {
    const res = await fetch(
      `/api/MemberLicensePlate/${member_licenseplate_id}`,
      {
        ...fetchTemplate,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return await res.json();
  }
}

export default new MemberLicensePlateService();

